import { takeLatest, call, put, all, delay } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/rotasp/api';
import { PATH_BU_PPT_RELATORIOS } from 'services/rotasp/path';

// ENTITIES
import { IProtocoloFic as IRequestProtocoloFic } from 'pages/iirgd/RgFicDigital/StatusCadastro/Buttons/ImprimirProtocolo/functions';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { treatRequest } from 'utils/functions/treatRequest';
import { setLoader } from 'store/modules/app/loader/actions';
import { Types } from './types';

// ACTIONS
import { protocoloFicSuccess, protocoloFicFailure } from './actions';
import { baixarArquivosRequest } from '../../utils/arquivos/baixarArquivos/actions';

function* protocoloFicRequest(request: ReducerActionRotaSP) {
	const { token, payload }: { token?: string; payload: IRequestProtocoloFic } =
		request;

	const cleanedPayload: any = treatRequest(payload);

	if (
		cleanedPayload.cidadao &&
		cleanedPayload.cidadao.enderecoTrabalho &&
		cleanedPayload.cidadao.enderecoTrabalho.municipio &&
		typeof cleanedPayload.cidadao.enderecoTrabalho.municipio === 'object' &&
		Object.keys(cleanedPayload.cidadao.enderecoTrabalho).length === 1 &&
		!cleanedPayload.cidadao.enderecoTrabalho.municipio.descricao
	) {
		delete cleanedPayload.cidadao.enderecoTrabalho;
	}

	const response: ApiResponse = yield call(
		postApi,
		token || '',
		PATH_BU_PPT_RELATORIOS,
		`fic`,
		cleanedPayload,
		undefined,
		undefined,
		undefined,
	);

	if (response.status === 201) {
		setLoader(true);
		yield delay(3000);
		if (response.data && response.data.pdfDataUrl) {
			yield put(
				baixarArquivosRequest(token || '', {
					url: response.data.pdfDataUrl,
					instanceRequest: 'protocolo_fic',
				}),
			);
		}
		yield put(protocoloFicSuccess(response.data));
	} else {
		console.error(
			'protocoloFicRequest failed:',
			response.error || response.status,
		);
		yield put(protocoloFicFailure());
	}
}

export default all([
	takeLatest(Types.PROTOCOLO_FIC_REQUEST, protocoloFicRequest),
]);
